import { render, staticRenderFns } from "./skiiScoreWZ.vue?vue&type=template&id=8e586a14&scoped=true"
import script from "./skiiScoreWZ.vue?vue&type=script&lang=js"
export * from "./skiiScoreWZ.vue?vue&type=script&lang=js"
import style0 from "./skiiScoreWZ.vue?vue&type=style&index=0&id=8e586a14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e586a14",
  null
  
)

export default component.exports